<template>
		<div class="empty_space">

		</div>
	</template>

	<script>

	import componentTools from '@/libs/componentTools.js';

	export default {
		name: 'empty_input',

	};
	</script>



// WEBPACK FOOTER //
// src/components/candidate_forms/empty_input.vue